export type BackgroundType = "color" | "gradient" | "image";

export interface Background {
  type?: BackgroundType;
  value?: string;
}

/**
 * Trả về CSS style cho background:
 * - 'color' ➝ backgroundColor
 * - 'gradient' ➝ backgroundImage
 * - 'image' ➝ backgroundImage + cover
 * Dùng chung cho tất cả components.
 */
export function getBackgroundStyle(
  background?: Background,
): React.CSSProperties {
  if (!background || !background.type || !background.value) return {};

  switch (background.type) {
    case "color":
      return { backgroundColor: background.value };
    case "gradient":
      return { backgroundImage: background.value };
    // case "image":
    //   return {
    //     backgroundImage: `url(${background.value})`,
    //     backgroundSize: "cover",
    //     backgroundPosition: "center",
    //   };
    default:
      return {};
  }
}

type ButtonVariant =
  | "default"
  | "secondary"
  | "destructive"
  | "outline"
  | "ghost"
  | "link";
export const getBtnVariant = (style?: string): ButtonVariant => {
  switch (style) {
    case "secondary":
      return "secondary";
    case "outline":
      return "outline";
    case "ghost":
      return "ghost";
    case "link":
      return "link";
    case "destructive":
      return "destructive";
    default:
      return "default"; // dùng cho "primary" hoặc không xác định
  }
};
export const paddingMap = {
  none: "",
  sm: "py-10 px-4",
  md: "py-16 px-6",
  lg: "py-20 px-6",
  xl: "py-28 px-8",
  "2xl": "py-32 px-12",
};
